import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ProjectAttachment} from 'types/attachements';

export type ProjectReorderItem = {
  id: number;
  display_type: string;
  display_order: number;
};

const reorderProjectsApi = api.injectEndpoints({
  endpoints: (build) => ({
    reorderProjects: build.mutation<void, { items: ProjectReorderItem[] }>({
      query: (body) => ({ url: 'projects/reorder', method: 'POST', body }),
      // @ts-expect-error
      invalidatesTags: ['Projects'],
    })
  }),
});

export type ProjectReorderPreviewItem = {
  id: ObjectId;
  name: { fr: string; en: string };
  project_type: string;
  display_type: string | null;
  display_order: number | null;
  project_image: ProjectAttachment | null;
};

export const { useReorderProjectsMutation } = reorderProjectsApi;
